//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as dd from 'dingtalk-jsapi';
function setupWebViewJavascriptBridge(callback) {
  if (window.WebViewJavascriptBridge) {
    return callback(WebViewJavascriptBridge);
  }
  if (window.WVJBCallbacks) {
    return window.WVJBCallbacks.push(callback);
  }
  window.WVJBCallbacks = [callback]; // 创建一个 WVJBCallbacks 全局属性数组，并将 callback 插入到数组中。
  var WVJBIframe = document.createElement('iframe'); // 创建一个 iframe 元素
  WVJBIframe.style.display = 'none'; // 不显示
  WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__'; // 设置 iframe 的 src 属性
  document.documentElement.appendChild(WVJBIframe); // 把 iframe 添加到当前文导航上。
  setTimeout(function () {
    document.documentElement.removeChild(WVJBIframe)
  }, 0)
}

export default {
  name: "mine",
  data() {
    return {
      currentPerson: {},
      headUrl: require('../../assets/icon/touxiang.png'),
      imgBaseUrl: process.env.API_ROOT,
      unReadMsg: null,
      driver:{}
    }
  },
  methods: {
    goJump(url){
      if(this.$route.meta && this.$route.meta.driver){
        this.$router.push(`/driver${url}`);
      }else{
        this.$router.push(url);
      }
    },
    backLastPage() {
      if (this.$store.state.device === 'wap') {
        this.$router.go(-1);
      } else {
        document.location = "http://action:10002/?";
      }
    },
    goMsgNotice() {
      if (this.$store.state.device === 'android' || this.$store.state.device === 'ios') {
        document.location = "http://action:6100/?"
      }
    },
    goSetting() {
      if (this.$store.state.device === 'android' || this.$store.state.device === 'ios') {
        document.location = "http://action:6014/?"
      }
    },
    logout() {
      console.log(this.currentPerson);
      if(dd.env.platform != 'notInDingTalk'){
        this.removeBind('ding');
        return
      }
      let ua = navigator.userAgent.toLowerCase();
      if(ua.match(/MicroMessenger/i) == "micromessenger"){
        if(ua.match(/WxWork/i) == "wxwork"){
          this.removeBind('enterpriseWx');
        }else{
          this.removeBind('wx');
        }
        return;
      }
      localStorage.removeItem('_token');
      if(this.$route.meta && this.$route.meta.driver){
        this.$router.push('/driver/login');
      }else{
        this.$router.push('/user/login');
      }
    },
    getCurrent() {
      this.$loadingShow();
      this.$get('api/person/current').then((data) => {
        this.$store.dispatch('commitChangeType', data.userType);
        this.$store.dispatch('commitChangeUserId', data.id);
        this.currentPerson = data;
        if(this.$route.meta.driver){
          this.$get(`api/driver/tel/${data.login}`).then((res) => {
            this.driver = res;
            this.$loadingHide();
          }).catch(() => {
            this.$loadingHide();
          })
        }else{
          this.$loadingHide();
        }
      }).catch(() => {
        this.$loadingHide();
      })
    },
    getUnreadmsg() {
      let that = this;
      if (this.$store.state.device === 'android') {
        if (window.MyWebView) {
          this.unReadMsg = window.MyWebView.getNativeParamValue('unreadmsg');
        }
      } else if (this.$store.state.device === 'ios') {
        setupWebViewJavascriptBridge(function (bridge) {
          bridge.callHandler('getIosUnreadNum',
            function callback(response) {
              that.unReadMsg = response.unReadNum;
            }
          );
          bridge.registerHandler('getUnreadNum', function (data) {
            that.unReadMsg = data.unReadNum;
          })
        });
      }
    },
    removeBind(str){
      console.log(str);
      this.$loadingShow();
      let url;
      if(str === 'ding'){
        url = 'api/ding-auth/logoutAndUnbind/ding';
      }else if(str === 'enterpriseWx'){
        url = 'api/logoutAndUnbind/enterpriseWx';
      }else{
        url = 'api/logoutAndUnbind/wx';
      }
      this.$get(url,{
        userId:this.currentPerson.user.id
      }).then((res) => {
        this.$loadingHide();
        localStorage.removeItem('_token');
        if(this.$route.meta && this.$route.meta.driver){
          if(res.data && res.data.userFlag){
            if(str === 'ding'){
              this.$router.push(`/driver/login?ddId=${res.data.userFlag}`);
            }else if(str === 'enterpriseWx'){
              this.$router.push(`/driver/login?qyOpenId=${res.data.userFlag}`);
            }else if(str === 'wx'){
              this.$router.push(`/driver/login?fwOpenId=${res.data.userFlag}`);
            }
          }else{
            this.$router.push(`/driver/login`);
          }
        }else{
          if(res.data && res.data.userFlag){
            if(str === 'ding'){
              this.$router.push(`/user/login?ddId=${res.data.userFlag}`);
            }else if(str === 'enterpriseWx'){
              this.$router.push(`/user/login?qyOpenId=${res.data.userFlag}`);
            }else if(str === 'wx'){
              this.$router.push(`/user/login?fwOpenId=${res.data.userFlag}`);
            }
          }else{
            this.$router.push(`/user/login`);
          }
        }
      }).catch(() => {
        this.$loadingHide();
        localStorage.removeItem('_token');
        if(this.$route.meta && this.$route.meta.driver){
          this.$router.push('/driver/login');
        }else{
          this.$router.push('/user/login');
        }
      });
    }
  },
  mounted() {
    this.getCurrent();
    this.getUnreadmsg();
    window.getUnreadmsg = this.getUnreadmsg;
  },
}



// WEBPACK FOOTER //
// ./src/page/home/mine.vue